import { render, staticRenderFns } from "./BlockImages.vue?vue&type=template&id=3f95eaee&scoped=true"
import script from "@/components/request/RequestDetail/block-images/BlockImages.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestDetail/block-images/BlockImages.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestDetail/block-images/block-images.scss?vue&type=style&index=0&id=3f95eaee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f95eaee",
  null
  
)

export default component.exports